import ACTIONS from "../actions/PricingTablesActions";
import _ from "lodash";

const initialState = {
    addCountryPricingModalOpen: false,
    editCountryPricingModalOpen: false,
    deleteCountryPriceWarning: false,
    addPricingSchemeModalOpen: false,
    countryPricingObject: {
        country_code: "",
        country_pricing_id: "",
        pricing_id: "",
        pricing_json: [],
        pricing_scheme: ""
    },
    pricingSchemeOptions: [
        {label: "FLAT", value: "FLAT"},
        {label: "VOLUME", value: "VOLUME"},
        {label: "TIERED", value: "TIERED"}
    ]
}

const AddEditCountryPricingReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.CountryPricingActionTypes.OPEN_EDIT_COUNTRY_PRICING_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.countryPricingObject = action.payload;
            newState.editCountryPricingModalOpen = !newState.editCountryPriceModalOpen;

            return newState
        }

        case ACTIONS.CountryPricingActionTypes.TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2: {
            let newState = _.cloneDeep(state);
            const { pricingID, pricingScheme, pricingJsonKey } = action.payload;
            newState.addCountryPricingModalOpen = !newState.addCountryPricingModalOpen;
            if (newState.addCountryPricingModalOpen) {
                newState.countryPricingObject.pricing_id = pricingID;
                newState.countryPricingObject.pricing_scheme = pricingScheme;
                if (pricingScheme === 'FLAT') {
                    newState.countryPricingObject.pricing_json.push({min: 0 , max: null, price: 0});
                } else {
                    newState.countryPricingObject.pricing_json = pricingJsonKey;
                    newState.countryPricingObject.pricing_json.forEach(p => {
                        p.price = 0;
                    });
                }

            } else {
                newState.countryPricingObject = initialState.countryPricingObject;
            }

            return newState
        }

        case ACTIONS.CountryPricingActionTypes.SET_COUNTRY_V2:{
            let newState = _.cloneDeep(state);
            if (action.payload.country !== null) {
                newState.countryPricingObject.country_code = action.payload.country.value;
            } else {
                newState.countryPricingObject.country_code = "";
            }
            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.SET_PRICING_SCHEME_V2:{
            let newState = _.cloneDeep(state);
            if (action.payload.pricingScheme !== null) {
                newState.countryPricingObject.pricing_scheme = action.payload.pricingScheme.value;
                if (action.payload.pricingScheme.value === "FLAT") {
                    // reset the json and add the flat-default tier
                    newState.countryPricingObject.pricing_json = [];
                    newState.countryPricingObject.pricing_json.push({min: 0 , max: null, price: 0});
                }
            } else {
                newState.countryPricingObject.pricing_scheme = "";
            }

            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.CLOSE_COUNTRY_PRICING_MODAL_V2: {
            return initialState;
        }

        case ACTIONS.CountryPricingActionTypes.EDIT_FLAT_PRICE_V2: {
            let newState = _.cloneDeep(state);
            if (action.payload === "") {
                newState.countryPricingObject.pricing_json[0].price = "";
            } else {
                newState.countryPricingObject.pricing_json[0].price = Number(action.payload);
            }
            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.EDIT_VOLUME_TIER_VALUES_V2: {
            let newState = _.cloneDeep(state);
            const { value, name, idx } = action.payload;
            if (value === "") {
                newState.countryPricingObject.pricing_json[idx][name] = "";
            } else {
                newState.countryPricingObject.pricing_json[idx][name] = Number(value);
            }

            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.ADD_VOLUME_TIER_V2: {
            let newState = _.cloneDeep(state);
            // const idx = action.payload;
            const currTierNumber = newState.countryPricingObject.pricing_json.length - 1;
            let prevMax = newState.countryPricingObject.pricing_json[currTierNumber].max;
            newState.countryPricingObject.pricing_json.push({min: prevMax+1, max: null, price: 0});

            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.DELETE_VOLUME_TIER_V2: {
            let newState = _.cloneDeep(state);
            // only deletes the last volume tier in the pricing_json
            newState.countryPricingObject.pricing_json = newState.countryPricingObject.pricing_json.slice(0, -1);

            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.DELETE_WARNING_FOR_COUNTRY_PRICING_V2: {
            let newState = _.cloneDeep(state);
            newState.deleteCountryPriceWarning = !newState.deleteCountryPriceWarning;
            newState.countryPricingIDForDelete = action.payload;

            return newState;
        }

        case ACTIONS.CountryPricingActionTypes.TOGGLE_ADD_PRICING_SCHEME_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.addPricingSchemeModalOpen = !newState.addPricingSchemeModalOpen;
            if (action.payload.pricingID !== "") {
                newState.countryPricingObject.pricing_id = action.payload.pricingID;
                newState.countryPricingObject.pricing_json.push({min:0 , max: 0, price: 0});
            } else {
                newState = initialState;
            }
            if (action.payload.volumeAggregationType === "GLOBAL" || action.payload.volumeAggregationType === "COUNTRY") {
                newState.pricingSchemeOptions = [
                    {label: "FLAT", value: "FLAT"},
                    {label: "VOLUME", value: "VOLUME"},
                ]
            } else if (action.payload.volumeAggregationType === "NONE") {
                newState.pricingSchemeOptions = [
                    {label: "FLAT", value: "FLAT"},
                    {label: "TIERED", value: "TIERED"},
                ]
            }

            return newState;
        }

        default:
            return state;
    }
}

export default AddEditCountryPricingReducer;
